import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, Optional, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AddEditCandidatePopupComponent } from '../add-edit-candidate-popup/add-edit-candidate-popup.component';

// Import these for date formatting
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

// Define your custom date format
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-external-candidate',
  templateUrl: './external-candidate.component.html',
  styleUrls: ['./external-candidate.component.scss'],
  providers: [    // The MomentDateAdapter can be configured with a locale and other options.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    // These are the formats that will be used by the datepicker.
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ExternalCandidateComponent implements OnInit {

  @ViewChild('resumeInput') resumeInput!: ElementRef<HTMLInputElement>;
  candidateForm!: FormGroup;
  isEditMode = false;
  isSubmitting = false;
  loading = false;
  selectedResumeName: string | null = null;
  sources: any;
  // sources = ['LinkedIn', 'Naukri', 'Internal Website', 'Other'];
  positionsList: string[] = [];
  filteredPositions: string[] = [];
  buttonColorName: string | null = null;
  subModuleButtonColor: string | null = null;
  positionName!: string;
  positionClosingDate?: Date;
  closingStatusMsg = '';
  jobDescription = '';
  loggedInUserCompanyID: string = '';
  fiscalYear: string = '';
  month: number = 0;
  imgurl: any;
  isAddedSuccessfully = false;
  positionCreatedById!: any;
  positionCreatedByName!: any;
  maxDobDate: Date = new Date();
  
  errorMessage: any;
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private httpService: HttpService,
    private config: Config,
    private dataRefreshService: DataRefreshService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    @Optional() private dialogRef: MatDialogRef<AddEditCandidatePopupComponent>,
  ) { }

  ngOnInit() {
    this.initForm({});
    combineLatest([
      this.route.paramMap,
      this.route.queryParamMap
    ]).subscribe(([paramMap, queryMap]) => {
      this.loggedInUserCompanyID = queryMap.get('companyId') || '';
      this.fiscalYear = queryMap.get('fiscalYear') || '';
      this.month = +(queryMap.get('month') || 0);
      const positionId = +(queryMap.get('positionId') || 0);

      history.replaceState({}, '', this.router.url.split('?')[0]);

      if (positionId) {
        this.loadJobDetails(positionId);

        this.fetchSources();
        this.getLogoData();
      }
    });
    
    this.candidateForm.get('email')?.valueChanges.subscribe(() => {
      this.errorMessage = null;
    });
  }
  fetchSources(): void {
    // const url = `${this.config.authgetJobPlatforms}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.fiscalYear}&month=${this.month}`;

    const url = `${this.config.authgetJobPlatforms}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.fiscalYear}`;

    this.http.get<any>(url).subscribe({
      next: (res: any) => {
        let data = res || [];

        data = data
          .filter((x: any) => !x.isDeleted)
          .map((x: any) => ({
            ...x,
            jobPlatformType: x.jobPlatformCode ? 'Firm' : 'Job Platform'
          }));

        this.sources = data;
      },
      error: err => {
        // console.error('Error fetching Job Platforms:', err);
        this.toastr.error('Failed to fetch Job Platforms.', 'Error');
      }
    });
  }
  hods: any;
  loadJobDetails(positionId: any): void {
    const params = new HttpParams()
      .set('positionId', String(positionId))
      .set('companyId', this.loggedInUserCompanyID)
      .set('fiscalYear', this.fiscalYear)
      .set('month', String(this.month));

    this.http.get<any>(this.config.getjobDescription, { params }).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          const jobData = res[0];
          // console.log('📌 Job API Response:', jobData);

          this.jobDescription = jobData.jobDescription || 'No job description available.';
          this.positionClosingDate = jobData.positionClosingDate
            ? new Date(jobData.positionClosingDate)
            : undefined;
          this.positionName = jobData.positionName || 'Unknown Position';
          this.positionCreatedById = jobData.positionCreatedById;
          this.positionCreatedByName = jobData.positionCreatedByName;
          const rawHods = jobData.hods || {};
          this.hods = Object.entries(rawHods).map(([hodId, hodName]) => ({
            hodId,
            hodName
          }));
          // console.log('📝 Form before patch:', this.candidateForm.value);

          // ✅ Patch form with position name and job description
          this.candidateForm.patchValue({
            positionId: jobData.positionId,          // ✅ use positionId
            positionCreatedByUserRole: jobData.positionCreatedByUserRole,
            positionAppliedFor: this.positionName,
            // Assuming you want to store job description in a hidden form control
            jobDescription: this.jobDescription,
            positionCreatedById: this.positionCreatedById,
            positionCreatedByName: this.positionCreatedByName,
            hods: this.hods,
          });

          if (this.positionClosingDate) {
            const today = new Date();
            const isOpen = this.positionClosingDate >= today;

            this.closingStatusMsg = isOpen
              ? '✅ Applications are still open'
              : '❌ Applications are closed';

            // Show toastr
            if (!isOpen) {
              this.toastr.error(
                'Applications are closed',
                'Closed',
                { timeOut: 3000, progressBar: true }
              );
            }
          }
        }
      },
      error: (err) => {
        // console.error('Failed to load job details', err);
        this.jobDescription = 'Failed to load job description.';
        this.closingStatusMsg = 'Unable to fetch closing date.';
      }
    });
  }

  private initForm(candidate: any): void {
    this.candidateForm = this.fb.group({
      name: [candidate.name || '', [Validators.required, Validators.maxLength(100)]],
      phone: [
        candidate.phone || '',
        [Validators.required, Validators.pattern(/^\d{10}$/),  Validators.maxLength(10),
          Validators.minLength(10)]
      ],
      email: [candidate.email || '',[Validators.required, Validators.email, Validators.maxLength(100)]],
      positionId: [candidate.positionId || null, Validators.required],
      positionCreatedById: [candidate.positionCreatedById || null, Validators.required],
      positionCreatedByName: [candidate.positionCreatedByName || null, Validators.required],
      positionCreatedByUserRole: [candidate.positionCreatedByUserRole || null, Validators.required],
      positionAppliedFor: [candidate.positionAppliedFor || '', Validators.required],
      applicationDate: [candidate.applicationDate || new Date(), Validators.required],
      resume: [candidate.resumeFile || '', Validators.required],
      source: [candidate.source || '', Validators.required],
      experienceYears: [candidate.yearOfExperience ?? null, [Validators.required, Validators.min(0), Validators.max(99)]],
      expectedSalary: [candidate.expectedSalary || '', [Validators.required, Validators.maxLength(20)]],
      skills: [candidate.skills || '',  [Validators.required, Validators.maxLength(200)]],
      education: [candidate.education || '', [Validators.required, Validators.maxLength(150)]],
      noticePeriod: [candidate.noticePeriod ?? null, [Validators.required, Validators.min(0), Validators.maxLength(3)]],
      // New fields
      currentCtc: [candidate.currentCtc || '',Validators.maxLength(20)],
      currentLocation: [candidate.currentLocation || '',[Validators.required,Validators.maxLength(100)]],
      preferredLocation: [candidate.preferredLocation || '',[Validators.required,Validators.maxLength(100)]],
      dob: [candidate.dob ? new Date(candidate.dob) : null],
      jobDescription: [candidate.jobDescription || ''],
      hods: [candidate.hods || {}]
    });
  }

  getLogoData() {
    this.http.get(`${this.config.logoGetData}?companyId=${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.imgurl = response.data?.logoUrl;
    })
  }
  onResumeUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;
    if (!input.files?.length) return; 
    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  
    if (!allowedTypes.includes(file.type)) {
      this.toastr.error('Only PDF or Word documents are allowed.');
      input.value = ''; // Clear invalid file
      return;
    }
    this.selectedResumeName = file.name;
    this.candidateForm.patchValue({ resume: file });
    this.candidateForm.get('resume')?.updateValueAndValidity();
  }

  onReset(): void {
    this.candidateForm.reset();
    this.resumeInput.nativeElement.value = '';
  }

  cancel(): void {
    this.dialogRef.close();
  }

  clearResume(): void {
    this.selectedResumeName = null;
    const fileInput = document.getElementById('resumeUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onlyNumberKey(event: KeyboardEvent): boolean {
    return /^[0-9]$/.test(event.key);
  }
  onSubmit(): void {
    if (this.candidateForm.valid) {
      this.isSubmitting = true;
      this.loading = true;

      const formValue = this.candidateForm.value;

      const formatDate = (date: Date): string => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
      };

      const payload: any = {
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.fiscalYear,
        month: this.month,
        name: formValue.name,
        phone: formValue.phone,
        email: formValue.email,
        positionAppliedFor: formValue.positionAppliedFor,
        applicationDate: formValue.applicationDate ? formatDate(formValue.applicationDate) : null,
        source: formValue.source,
        yearOfExperience: formValue.experienceYears,
        skills: formValue.skills,
        education: formValue.education,
        expectedSalary: formValue.expectedSalary,
        noticePeriod: formValue.noticePeriod,
        currentCtc: formValue.currentCtc || null,
        currentLocation: formValue.currentLocation || '',
        preferredLocation: formValue.preferredLocation || '',
        dob: formValue.dob ? formatDate(formValue.dob) : null,
        hods: formValue.hods,
        positionId: formValue.positionId,           // ✅ save positionId 
        positionCreatedById: formValue.positionCreatedById,
        positionCreatedByName: formValue.positionCreatedByName,
        positionCreatedByUserRole: formValue.positionCreatedByUserRole
      };
      // console.log('🔍 Form Submission Payload:', payload);

      const formData = new FormData();
      formData.append('dto', JSON.stringify(payload));

      if (formValue.resume) {
        formData.append('resumeFile', formValue.resume);
      }

      this.httpService.submitFileServiceWithoutAuth(this.config.addCandidatewithoutauth, formData, 'POST')
        .subscribe({
          next: (res:any) => {
            // this.dataRefreshService.triggerRefresh();
            // this.toastr.success('Candidate added successfully.', 'Success');
            // this.dialogRef.close();
            // this.isAddedSuccessfully = true;
            // this.isSubmitting = false;
           // // this.loading = false;
            if (res?.status) {
              // ✅ Close only if status is true
              this.toastr.success(
                this.isEditMode ? 'Updated successfully' : 'Applied successfully',
                'Success',
                { timeOut: 3000, progressBar: true }
              );
              this.dialogRef.close(true);
            } else {
              // ❌ Keep dialog open, show inline message
              this.errorMessage = res?.message || 'Something went wrong.';
              this.toastr.error(this.errorMessage, 'Error', {
                timeOut: 4000,
                progressBar: true,
                closeButton: true,
              });
            }
            this.isSubmitting = false;
          },
          error: (err) => {
            // console.error("Error adding candidate:", err);
            this.toastr.error('Failed to applied.', 'Error');
            // this.loading = false;
          }
        });

    } else {
      this.candidateForm.markAllAsTouched();
      const invalidFields = Object.entries(this.candidateForm.controls)
        .filter(([_, control]) => control.invalid)
        .map(([key, control]) => ({ key, errors: control.errors }));
      // console.warn('Invalid fields:', invalidFields);
    }
  }

}
